var map = {
	"./contact/createHandleSubmit": 982,
	"./cpo/createHandleSubmit": 983,
	"./customer/createHandleSubmit": 984,
	"./forwarderPo/createHandleSubmit": 985,
	"./incomingInvoice/createHandleSubmit": 986,
	"./incomingPayment/createHandleSubmit": 987,
	"./outgoingInvoice/createHandleSubmit": 988,
	"./outgoingPayment/createHandleSubmit": 1096,
	"./outgoingQuote/createHandleSubmit": 989,
	"./product/createHandleSubmit": 990,
	"./receiving/createHandleSubmit": 991,
	"./shipping/createHandleSubmit": 992,
	"./spo/createHandleSubmit": 1103,
	"./spoSched/createHandleSubmit": 993,
	"./vatDeductRecord/createHandleSubmit": 994,
	"./vendor/createHandleSubmit": 995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;